__turbopack_context__.v({
  "active": "DyZFGG_active",
  "container": "DyZFGG_container",
  "container-fluid": "DyZFGG_container-fluid",
  "container-lg": "DyZFGG_container-lg",
  "container-md": "DyZFGG_container-md",
  "container-sm": "DyZFGG_container-sm",
  "container-xl": "DyZFGG_container-xl",
  "container-xxl": "DyZFGG_container-xxl",
  "dropdown-menu": "DyZFGG_dropdown-menu",
  "nav": "DyZFGG_nav",
  "nav-link": "DyZFGG_nav-link",
  "navBar": "DyZFGG_navBar",
  "navContainer": "DyZFGG_navContainer",
  "navItem": "DyZFGG_navItem",
  "navSearchBox": "DyZFGG_navSearchBox",
  "navToggle": "DyZFGG_navToggle",
  "navbar": "DyZFGG_navbar",
  "navbar-brand": "DyZFGG_navbar-brand",
  "navbar-collapse": "DyZFGG_navbar-collapse",
  "navbar-dark": "DyZFGG_navbar-dark",
  "navbar-expand": "DyZFGG_navbar-expand",
  "navbar-expand-lg": "DyZFGG_navbar-expand-lg",
  "navbar-expand-md": "DyZFGG_navbar-expand-md",
  "navbar-expand-sm": "DyZFGG_navbar-expand-sm",
  "navbar-expand-xl": "DyZFGG_navbar-expand-xl",
  "navbar-expand-xxl": "DyZFGG_navbar-expand-xxl",
  "navbar-nav": "DyZFGG_navbar-nav",
  "navbar-nav-scroll": "DyZFGG_navbar-nav-scroll",
  "navbar-text": "DyZFGG_navbar-text",
  "navbar-toggler": "DyZFGG_navbar-toggler",
  "navbar-toggler-icon": "DyZFGG_navbar-toggler-icon",
  "offcanvas": "DyZFGG_offcanvas",
  "offcanvas-body": "DyZFGG_offcanvas-body",
  "offcanvas-header": "DyZFGG_offcanvas-header",
  "show": "DyZFGG_show",
});
